import * as React from 'react';
import {Main} from "../components/Main";
import {CheckBox} from "../components/sharedComponents/Forms";
import Services from "../utilities/Services";
import {Box} from "../components/sharedComponents/Box";
import {NotificationManager} from "react-notifications";
import InputMask from "react-input-mask";
import {isEmpty, validateNip} from "../utilities/Utilities";
import Req from "../components/Req";
import axios from "axios";

interface MatchParams {
    path: string;
}

export interface RouteComponentProps<MatchParams> {
    match: any;
    history: any;
}

interface State {

    isCompany: boolean,
    setCompany: boolean,
    isRegister: boolean,
    migracja: boolean,
    repeatPass: any,
    inputValues: any,
    oddzialy: any,
    kraje: any,
    loading: boolean,
    rejestracja: boolean,
    nipInvalid: any,
    nipMessage: string,
    migrationRest: any,
    loginError: boolean
    loginErrorMessage: any,
    loadingWeryfikacja: boolean
}

interface Props extends RouteComponentProps<MatchParams> {
}

export class Register extends React.Component<Props, State> {

    constructor(props: any) {
        super(props);

        this.state = {
            isCompany: false,
            setCompany: false,
            isRegister: false,
            nipInvalid: false,
            nipMessage: '',
            migracja: false,
            repeatPass: '',
            oddzialy: [],
            loginError: false,
            loginErrorMessage: false,
            loadingWeryfikacja: false,
            kraje: [],
            loading: false,
            rejestracja: false,
            migrationRest: [],
            inputValues:
                {
                    "login": "",
                    "konto_zablokowane": 0,
                    "nazwa_top": "",
                    "numer_magazynu": '',
                    "kraj": "PL",
                    "kraj_firma": "PL",
                    "zgoda_regulamin": 0,
                    "zgoda_wiek16": 0,
                    "zgoda_newsletter": 0,
                    "zgoda_karta": 0,
                    "zgoda_push": 0,
                    "pole_imie": "",
                    "pole_nazwisko": "",
                    "pole_firma": "",
                    "pole_firma_kontynuacja": "",
                    "pole_ulica": "",
                    "pole_nr_domu": "",
                    "pole_nr_mieszkania": "",
                    "pole_kod_pocztowy": "",
                    "pole_miejscowosc": "",
                    "pole_telefon": "",
                    "pole_nip": "",
                    "czy_firma": false,
                    "top_kod_sprzedawcy": '',
                    "password": "",
                    "email": "",
                    "id": ''
                }
        }

    }

    componentDidMount() {
        let {match} = this.props;

        if (match)
            if (match.params)
                if (match.params.migracja)
                {
                    if(match.params.migracja === 'migracja'){
                        if(sessionStorage.getItem('migrationData')){
                            this.setState({migracja: true});
                            this.przygotujDaneDoMigracji(JSON.parse(String(sessionStorage.getItem('migrationData'))))
                        }
                    }
                }

        this.pobierzOddzialy();
        this.pobierzKrajeFirma();
    }

    przygotujDaneDoMigracji = (migrationData: any) => {
        let data = {
            "login": this.returnValue(migrationData.login, ''),
            "konto_zablokowane": 0,
            "nazwa_top": this.returnValue(migrationData.nazwa_top, ''),
            "numer_magazynu": (isEmpty(migrationData.numer_magazynu)) ? '' : migrationData.numer_magazynu,
            "kraj": (migrationData.typMigracji === 'migration/editoTop')? 'PL' : this.returnValue(migrationData.kraj, 'PL'),
            "kraj_firma": this.returnValue(migrationData.kraj_firma, 'PL'),
            "zgoda_regulamin": 0,
            "zgoda_wiek16": migrationData.zgoda_wiek16,
            "zgoda_newsletter": migrationData.zgoda_newsletter,
            "zgoda_karta": migrationData.zgoda_karta,
            "zgoda_push": migrationData.zgoda_push,
            "pole_imie": this.returnValue(migrationData.pole_imie, ''),
            "pole_nazwisko": this.returnValue(migrationData.pole_nazwisko, ''),
            "pole_firma": this.returnValue(migrationData.pole_firma, ''),
            "pole_firma_kontynuacja": this.returnValue(migrationData.pole_firma_kontynuacja, ''),
            "pole_ulica": this.returnValue(migrationData.pole_ulica, ''),
            "pole_nr_domu": this.returnValue(migrationData.pole_nr_domu, ''),
            "pole_nr_mieszkania": this.returnValue(migrationData.pole_nr_mieszkania, ''),
            "pole_kod_pocztowy": this.returnValue(migrationData.pole_kod_pocztowy, ''),
            "pole_miejscowosc": this.returnValue(migrationData.pole_miejscowosc, ''),
            "pole_telefon": this.returnValue(migrationData.pole_telefon, ''),
            "pole_nip": this.returnValue(migrationData.pole_nip, ''),
            "czy_firma": (this.returnValue(migrationData.pole_nip, '').length > 0),
            "top_kod_sprzedawcy": '',
            "password": this.returnValue(migrationData.haslo, ''),
            "email": this.returnValue(migrationData.login, ''),
            "id": this.returnValue(migrationData.id, '0')
        }

        if (data.czy_firma){
            this.setState({isCompany: true});
            data.pole_imie='';
            data.pole_nazwisko='';


        } else {
            this.setState({isCompany: false});
            data.pole_firma='';
            data.pole_firma_kontynuacja='';
            data.pole_nip='';

        }

        this.setState({inputValues: data, repeatPass: '', migrationRest: migrationData});
        sessionStorage.removeItem('migrationData');
    }

    returnValue = (val: any, defVal: string) => {
        if (isEmpty(val)){
            return defVal;
        } else {
            return String(val);
        }

    };

    handleOnChange = (e: React.FormEvent<HTMLInputElement>) => {
        const {name, value}: any = e.target;
        let input = this.state.inputValues;

        if(name === 'login'){
            input[name] = value.toLowerCase();
        } else {
            input[name] = value;
        }

        this.setState({inputValues: input});
    };

    handleOnChecked = (e: React.FormEvent<HTMLInputElement>) => {
        const {name, checked}: any = e.target;
        let input = this.state.inputValues;
        input[name] = checked? 1 : 0;
        this.setState({inputValues: input});
    };

    handleOnChangerepeatPass = (e: React.FormEvent<HTMLInputElement>) => {
        const {value}: any = e.target;
        this.setState({repeatPass: value});
    }

    pobierzKrajeFirma = () => {
        this.setState({loading: true});

        Services.getKrajeFirma().then((response) => {

            console.log("get Kraje ok");

            this.setState({kraje: response.data});

        }).catch((error) => {
                this.setState({loading: false});
                console.log('get Kraje error');
            }
        )
    }

    pobierzOddzialy = () => {
        this.setState({loading: true});

        Services.getOddzialyRegister().then((response) => {

                console.log("get Oddzialy ok");

            this.setState({oddzialy: response.data, loading: false});

                // this.setState({oddzialy: response.data.sort(
                //         (a: any, b: any) => {
                //             return a.adres.localeCompare(
                //                 b.adres,
                //             );
                //         },
                //     ).map((oddzial: any) => {return oddzial}), loading: false});

            }).catch((error) => {
                this.setState({loading: false});
                console.log('get Oddzialy error');
            }
        )
    }

    onChangeKrajFirma = (e: any) => {
        //@ts-ignore
        console.log(e.target.value);

        let input = this.state.inputValues;
        input['kraj_firma']=e.target.value;
        this.setState({inputValues: input});

        if(this.state.inputValues.pole_nip.length > 0){
            this.checkNip();
        } else {
            this.setState({nipInvalid: true, nipMessage: 'Podaj NIP'});
        }

    }

    onChangeSklep = (e: any) => {
        //@ts-ignore
        console.log(e.target.value);

        let input = this.state.inputValues;
        input['numer_magazynu']=e.target.value;
        this.setState({inputValues: input});
    }

    submitForm = (e: React.FormEvent<any>) => {
        e.preventDefault()

        // if (!this.state.isCompany)
        // {
        //     let input = this.state.inputValues;
        //     input['topNazwa']=input['firma'].slice(0, 20);
        //     this.setState({inputValues: input});
        // }

        const data = this.state.inputValues;

        data['email'] = data.login;
        data['czy_firma'] = this.state.isCompany? 1 : 0;
        data['numer_magazynu'] = Number(data['numer_magazynu']);
        // data['pole_kod_pocztowy'] = data.pole_kod_pocztowy.replace('_','');

        if(this.state.migracja){
            this.setState({rejestracja: true});
            this.Migruj(data);
        } else {
            if(data.password === this.state.repeatPass)
            {
                this.setState({rejestracja: true});

                Services.SprawdzHaslo(data.password).then((response) => {
                    if (response.status === 200){
                        this.Rejestruj(data);
                    }
                }).catch((error) => {
                    NotificationManager.error(error.response.data.message, 'Błąd rejestracji', 5000);
                    this.setState({rejestracja: false});
                })

            }
            else
            {
                NotificationManager.error('Podane hasła są różne', 'Błąd rejestracji', 5000);
            }
        }
    }

    Migruj = (data: any) => {
        let login = this.state.migrationRest.login;
        let haslo = this.state.migrationRest.haslo;
        let typMi = this.state.migrationRest.typMigracji;

        Services.Migracja(data, typMi).then((response) => {

                Services.Zaloguj(login, haslo).then((response) => {

                    let token = 'Basic ' + btoa(login + ':' + haslo)

                    axios.defaults.headers.common.Authorization = token;

                    sessionStorage.setItem('isUserLoggedMM',
                        JSON.stringify(Object.assign({}, response.data, {token: token}))
                    )

                    window.location.replace('/konto');

                }).catch(error => {
                    NotificationManager.error(error.response.data.message, 'Błąd logowania', 5000);
                    window.location.replace('/login');
                })

            }).catch((error) => {

            NotificationManager.error(error.response.data.message, 'Błąd aktualizacji danych', 5000);
            this.setState({rejestracja: false});

        })
    }

    Rejestruj = (data: any) => {

        Services.Register(data)
            .then((response) => {
                if (response.status === 200) {

                    this.setState({isRegister: true, rejestracja: false});

                }
            }).catch((error) => {

            NotificationManager.error(error.response.data.message, 'Błąd rejestracji', 5000);
            this.setState({rejestracja: false});

        })

    }

    changeTypKonta = (e: any) => {
        let input = this.state.inputValues;
        input['czy_firma'] = e.checked;
        this.setState({inputValues: input});
    }

    czyscPola() {

        if(!this.state.migracja){
            this.setState({inputValues:
                    {
                        "login": "",
                        "konto_zablokowane": 0,
                        "nazwa_top": "",
                        "numer_magazynu": '',
                        "kraj": "PL",
                        "kraj_firma": "PL",
                        "zgoda_regulamin": 0,
                        "zgoda_wiek16": 0,
                        "zgoda_newsletter": 0,
                        "zgoda_karta": 0,
                        "zgoda_push": 0,
                        "pole_imie": "",
                        "pole_nazwisko": "",
                        "pole_firma": "",
                        "pole_firma_kontynuacja": "",
                        "pole_ulica": "",
                        "pole_nr_domu": "",
                        "pole_nr_mieszkania": "",
                        "pole_kod_pocztowy": "",
                        "pole_miejscowosc": "",
                        "pole_telefon": "",
                        "pole_nip": "",
                        "czy_firma": this.state.isCompany,
                        "top_kod_sprzedawcy": '',
                        "password": "",
                        "email": "",
                        "id": ''
                    }, repeatPass: '', nipInvalid: false, nipMessage: '', loginErrorMessage: false}
            )
        }
    }

    checkNip = () => {
        if(this.state.inputValues.pole_nip.length > 0){
            Services.WeryfikujNip(this.state.inputValues.kraj_firma, this.state.inputValues.pole_nip).then((response) => {
                this.setState({nipMessage: response.data.message});
                if(response.data.countryValid === false && response.data.euValid === false){
                    this.setState({nipInvalid: true});
                } else {
                    this.setState({nipInvalid: false});
                }
            }).catch((e) => {
                this.setState({nipInvalid: true, nipMessage: e.response.data.message});
            })
        } else {
            this.setState({nipInvalid: true, nipMessage: 'Podaj NIP'});
        }

        // if (validateNip(this.state.inputValues.pole_nip)) {
        //     this.setState({nipInvalid: false});
        // } else {
        //     this.setState({nipInvalid: true})
        // }
    }

    sprawdzLogin = () => {
        if(!this.state.migracja){
            this.setState({loadingWeryfikacja: true});
            Services.weryfikujLogin(this.state.inputValues.login).then((response) => {
                this.setState({loginError: false, loadingWeryfikacja: false, loginErrorMessage: true});
            }).catch((e) => {
                this.setState({loginError: true, loginErrorMessage: e.response.data.message, loadingWeryfikacja: false});
            })
        }
    }

    render()
    {
        let {inputValues, isCompany, isRegister, repeatPass, oddzialy, rejestracja, migracja, nipInvalid, nipMessage, kraje, loginError, loginErrorMessage, loadingWeryfikacja} = this.state;
        return(
            (!isRegister)?
                <Main active={'REGISTER'}>
                    <Box>
                    <h3>{(migracja)? 'Aktualizacja danych' : 'Rejestracja'}</h3>
                    {(migracja)?
                        <p>Uzupełnij brakujące informacje o koncie.</p>
                        :
                        <p>W celu rejestracji wprowadź poprawnie swoje dane, po ich wysłaniu otrzymasz wiadomość z linkiem do
                            pobrania aplikacji mobilnej Merkury Market.</p>
                    }
                    <form onSubmit={this.submitForm.bind(this)}>
                        <section className={'register-form'}>
                            <div className={'row'}>
                                <div className={'col-sm-2 pr-0'}>
                                    <span>Login (e-mail):<Req/></span>
                                </div>
                                <div className={'col-sm-10'}>
                                    <input required type={'email'} className={'form-control'} value={inputValues.login} autoFocus={true}
                                           onChange={this.handleOnChange} disabled={migracja} onBlur={() => this.sprawdzLogin()} autoComplete="off"
                                           name={'login'}/>
                                    {/*{(loginError)&&*/}
                                    {/*    <p>{loginErrorMessage}</p>*/}
                                    {/*}*/}
                                    {(loadingWeryfikacja)?
                                        <p><i className="fa fa-spinner fa-spin"/> weryfikacja...</p>
                                        :
                                        <p style={{color: loginError? 'red' : 'green', display: 'block'}}>{(loginError)? <div>{loginErrorMessage} <a href={'/login'}>Zaloguj się <i className="fa fa-hand-pointer-o"/></a></div> : (loginErrorMessage === true)&&<div><i className="fa fa-check" style={{color: 'green'}}/> Login OK</div>}</p>
                                    }
                                </div>
                                {/*
                        <div className={'col-sm-2'}>
                            <span>E-mail:</span>
                        </div>
                        <div className={'col-sm-10'}>
                            <input type={'text'} className={'form-control'} value={inputValues.email}
                                   onChange={handleOnChange}
                                   name={'emailes'}/>
                        </div>
                        */}
                                {(!migracja)&&<>
                                    <div className={'col-sm-2 pr-0'}>
                                        <span>Hasło:<Req/></span>
                                    </div>
                                        <div className={'col-sm-10'}>
                                            <input required type={'password'} className={'form-control'} value={inputValues.password}
                                            // pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).{8,}"
                                            title="Minimum 8 znaków, duże i małe litery oraz znaki specjalne"
                                            onChange={this.handleOnChange}
                                            name={'password'}/>
                                        </div>
                                        <div className={'col-sm-2 pr-0'}>
                                        <span>Powtórz hasło:<Req/></span>
                                        </div>
                                        <div className={'col-sm-10'}>
                                            <input required type={'password'} className={'form-control'}
                                            // pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).{8,}"
                                            title="Minimum 8 znaków, duże i małe litery oraz znaki specjalne"
                                            value={repeatPass}
                                            onChange={this.handleOnChangerepeatPass}/>
                                        </div>
                                </>
                                }

                                {/*<div className={'col-sm-2'}>*/}
                                {/*    <span>Kraj:</span>*/}
                                {/*</div>*/}
                                {/*<div className={'col-sm-10'} style={{paddingBottom: '12px'}}>*/}
                                {/*    <select id="kraj" name={"kraj"} className={"form-control"} onChange={(e: any) => this.handleOnChange(e)}*/}
                                {/*            value={inputValues.kraj}*/}
                                {/*            required>*/}
                                {/*        <option value="" disabled selected>wybierz...</option>*/}
                                {/*        <option value="pl">Polska</option>*/}
                                {/*        <option value="cz">Czechy</option>*/}
                                {/*        <option value="sk">Słowacja</option>*/}
                                {/*    </select>*/}
                                {/*</div>*/}
                                {(migracja)?
                                    <>
                                        <div className={'col-sm-2 pr-0'}>
                                            <span>Typ konta:</span>
                                        </div>
                                        <div className={'col-sm-10'} style={{lineHeight: '38px'}}>
                                            {(isCompany)? 'Firma' : 'Osoba fizyczna'}
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className={'col-sm-2 pr-0'}>
                                            <span>Typ konta:</span>
                                        </div>
                                        <div className={'col-sm-10'}>
                                            <div className={'radio-line'}>
                                                <input type={'radio'} checked={!isCompany} onChange={() => {this.setState({isCompany: !isCompany}); this.czyscPola();}}
                                                       name={'companyFalse'} id={"person"} disabled={migracja}/> <label htmlFor="person">Osoba
                                                fizyczna</label>
                                                <input type={'radio'} checked={isCompany} onChange={() => {this.setState({isCompany: !isCompany}); this.czyscPola();}}
                                                       name={'companyTrue'} id={"company"} disabled={migracja}/> <label htmlFor="company">Firma</label>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                            {isCompany ?
                                <div className={'row'}>
                                    <div className={'col-sm-2 pr-0'}>
                                        <span>Nazwa skrócona:<Req/></span>
                                    </div>
                                    <div className={'col-sm-10'}>
                                        <input type={'text'} className={'form-control'}
                                               value={inputValues.nazwa_top}
                                               disabled={migracja}
                                               maxLength={20}
                                               required
                                               placeholder={'Maksymalnie 20 znaków'}
                                               onChange={this.handleOnChange}
                                               name={'nazwa_top'}/>
                                    </div>
                                    <div className={'col-sm-2 pr-0'} style={{marginBottom: '15px'}}>
                                        <span>Kraj:<Req/></span>
                                    </div>
                                    <div className={'col-sm-10'} style={{marginBottom: '15px'}}>
                                        <select className={'form-control'}
                                                placeholder={'Wybierz...'}
                                                onChange={this.onChangeKrajFirma}
                                                required={true}
                                                value={inputValues.kraj_firma}
                                            //@ts-ignore
                                            //     value={((user.numag) !== 0) ? user.numag : null}
                                        >
                                            <option disabled selected>Wybierz kraj...</option>
                                            {
                                                kraje.map((kraj: any) => (
                                                    <option value={kraj.value}>{kraj.label}</option>
                                                ))
                                            }
                                        </select>

                                    </div>
                                    <div className={'col-sm-2 pr-0'}>
                                        <div>NIP:<Req/></div>
                                    </div>
                                    <div className={'col-sm-10'}>
                                        <span>Jeżeli jesteś obcokrajowcem z obszaru EU podaj nip europejski VAT EU</span>
                                        <span style={{color: nipInvalid? 'red' : 'green', display: 'block'}}>{nipMessage}</span>
                                        <input required type={'text'} pattern="[0-9]*" className={'form-control'} value={inputValues.pole_nip}
                                               onBlur={() => this.checkNip()}
                                               onChange={this.handleOnChange}
                                               disabled={migracja}
                                               name={'pole_nip'}/>
                                    </div>
                                    <div className={'col-sm-2 pr-0'}>
                                        <span>Firma:<Req/></span>
                                    </div>
                                    <div className={'col-sm-10'}>
                                        <input required type={'text'} className={'form-control'} value={inputValues.pole_firma}
                                               maxLength={90}
                                               onChange={this.handleOnChange}
                                               disabled={migracja}
                                               name={'pole_firma'}/>
                                    </div>
                                    <div className={'col-sm-2 pr-0'}>
                                        <span>Firma c.d.:</span>
                                    </div>
                                    <div className={'col-sm-10'}>
                                        <input type={'text'} className={'form-control'}
                                               value={inputValues.pole_firma_kontynuacja}
                                               disabled={migracja}
                                               maxLength={90}
                                               onChange={this.handleOnChange}
                                               name={'pole_firma_kontynuacja'}/>
                                    </div>
                                    <div className={'col-sm-2 pr-0'}>
                                        <span>Telefon:<Req/></span>
                                    </div>
                                    <div className={'col-sm-10'}>
                                        <input required type={'text'} className={'form-control'}
                                               value={inputValues.pole_telefon}
                                               onChange={this.handleOnChange}
                                               name={'pole_telefon'}/>
                                    </div>
                                    <div className={'col-sm-2 pr-0'}>
                                        <span>Kod pocztowy:<Req/></span>
                                    </div>
                                    <div className={'col-sm-10'}>
                                        <InputMask mask={[/\d/, /\d/, '-', /\d/, /\d/, /\d/]} className={'form-control'} style={{maxWidth: '120px', marginBottom: '10px'}}
                                                   value={inputValues.pole_kod_pocztowy}
                                                   onChange={this.handleOnChange}
                                                   name={'pole_kod_pocztowy'}
                                                   minLength={5}
                                                   required
                                        />
                                        {/*<input required type={'text'} className={'form-control'} style={{maxWidth: '120px'}}*/}
                                        {/*       value={inputValues.pole_kod_pocztowy}*/}
                                        {/*       minLength={5} maxLength={6}*/}
                                        {/*       onChange={this.handleOnChange}*/}
                                        {/*       name={'pole_kod_pocztowy'}/>*/}
                                    </div>
                                    <div className={'col-sm-2 pr-0'}>
                                        <span>Miejscowość:<Req/></span>
                                    </div>
                                    <div className={'col-sm-10'}>
                                        <input required type={'text'} className={'form-control'} value={inputValues.pole_miejscowosc}
                                               onChange={this.handleOnChange}
                                               maxLength={50}
                                               name={'pole_miejscowosc'}/>
                                    </div>
                                    <div className={'col-sm-2 pr-0'}>
                                        <span>Nazwa ulicy:</span>
                                    </div>
                                    <div className={'col-sm-10'}>
                                        <input type={'text'} className={'form-control'}
                                               value={inputValues.pole_ulica}
                                               onChange={this.handleOnChange}
                                               maxLength={40}
                                               name={'pole_ulica'}/>
                                    </div>
                                    <div className={'col-sm-2 pr-0'}>
                                        <span>Nr domu:<Req/></span>
                                    </div>
                                    <div className={'col-sm-10'}>
                                        <input required type={'text'} className={'form-control'} style={{maxWidth: '120px'}}
                                               value={inputValues.pole_nr_domu}
                                               onChange={this.handleOnChange}
                                               name={'pole_nr_domu'}/>
                                    </div>
                                    <div className={'col-sm-2 pr-0'}>
                                        <span>Nr mieszkania:</span>
                                    </div>
                                    <div className={'col-sm-10'}>
                                        <input type={'text'} className={'form-control'} style={{maxWidth: '120px'}}
                                               value={inputValues.pole_nr_mieszkania}
                                               onChange={this.handleOnChange}
                                               name={'pole_nr_mieszkania'}/>
                                    </div>

                                    <div className={'col-sm-2 pr-0'} style={{marginBottom: '15px'}}>
                                        <span>Twój sklep:<Req/></span>
                                    </div>
                                    <div className={'col-sm-10'} style={{marginBottom: '15px'}}>
                                        <select className={'form-control'}
                                                placeholder={'Wybierz...'}
                                                onChange={this.onChangeSklep}
                                                value={inputValues.numer_magazynu}
                                                required={true}
                                            //@ts-ignore
                                            //      value={((inputValues.numer_magazynu) !== 0) ? inputValues.numer_magazynu : null}
                                        >
                                            <option value={''} disabled selected hidden>Wybierz twój sklep...</option>
                                            {
                                                oddzialy.map((oddzial: any) => (
                                                    <option value={oddzial.numag}>{oddzial.adresPelen}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                    <div className={'col-sm-10 my-auto pr-0'} style={{textAlign: 'right'}}>
                                        <span>Numer Sprzedawcy polecającego:</span>
                                    </div>
                                    <div className={'col-sm-2 my-auto'}>
                                        {/*<InputMask mask={'aa'} className={'form-control'} style={{maxWidth: '40px'}}*/}
                                        {/*           value={inputValues.kodSprzedawcy}*/}
                                        {/*           onChange={this.handleOnChange}*/}
                                        {/*           name={'kodSprzedawcy'}*/}
                                        {/*/>*/}
                                        <input type={'text'} className={'form-control'} style={{maxWidth: '120px'}}
                                               value={inputValues.top_kod_sprzedawcy}
                                               onChange={this.handleOnChange}
                                               name={'top_kod_sprzedawcy'}/>
                                    </div>

                                    <div className={'col-sm-12'} style={{marginBottom: '25px'}}>
                                    </div>

                                    <div className={'col-sm-12'}>
                                        <CheckBox required={true} name={'zgoda_regulamin'} checked={inputValues.zgoda_regulamin} handleOnChange={this.handleOnChecked}/>
                                        <span className={'checkbox-span'}><i>*</i> Oświadczam, iż zapoznałem się i akceptuję Regulamin programu lojalnościowego Karta Stałego Klienta  </span>
                                    </div>

                                    <div className={'col-sm-12'}>
                                        <CheckBox required={false} name={'zgoda_newsletter'} checked={inputValues.zgoda_newsletter} handleOnChange={this.handleOnChecked}/>
                                        <span className={'checkbox-span'}>Zgodnie z art. 6 ust. 1 lit. a) RODO wyrażam zgodę na przetwarzanie moich danych osobowych w celu subskrypcji newslettera Merkury Market Spółka z ograniczoną odpowiedzialnością Sp.k. z siedzibą w Krośnie.                            </span>
                                    </div>

                                    <div className={'col-sm-12'}>
                                        <CheckBox required={false} name={'zgoda_push'} checked={inputValues.zgoda_push} handleOnChange={this.handleOnChecked}/>
                                        <span className={'checkbox-span'}>Wyrażam zgodę na używanie telekomunikacyjnych urządzeń końcowych (np. telefonu) dla celów marketingu bezpośredniego przez Merkury Market Spółka z ograniczoną odpowiedzialnością Sp.k. z siedzibą w Krośnie. </span>
                                    </div>

                                    {/*<div className={'col-sm-2'}>*/}
                                    {/*    <CheckBox required={true} name={'zgoda_regulamin'} checked={inputValues.zgoda_regulamin} handleOnChange={this.handleOnChecked}/>*/}
                                    {/*</div>*/}
                                    {/*<div className={'col-sm-10 mb-2'}>*/}
                                    {/*    <span className={'checkbox-span'}><i>*</i> Oświadczam, iż zapoznałem się i akceptuję Regulamin programu lojalnościowego Karta Stałego Klienta  </span>*/}
                                    {/*</div>*/}
                                    {/*<div className={'col-sm-2'}>*/}
                                    {/*    <CheckBox required={false} name={'zgoda_newsletter'} checked={inputValues.zgoda_newsletter} handleOnChange={this.handleOnChecked}/>*/}
                                    {/*</div>*/}
                                    {/*<div className={'col-sm-10 mb-2'}>*/}
                                    {/*    <span className={'checkbox-span'}>Zgodnie z art. 6 ust. 1 lit. a) RODO wyrażam zgodę na przetwarzanie moich danych osobowych w celu subskrypcji newslettera Merkury Market Spółka z ograniczoną odpowiedzialnością Sp.k. z siedzibą w Krośnie.                            </span>*/}
                                    {/*</div>*/}
                                    {/*<div className={'col-sm-2'}>*/}
                                    {/*    <CheckBox required={false} name={'zgoda_push'} checked={inputValues.zgoda_push} handleOnChange={this.handleOnChecked}/>*/}
                                    {/*</div>*/}
                                    {/*<div className={'col-sm-10 mb-2'}>*/}
                                    {/*    <span className={'checkbox-span'}>Wyrażam zgodę na używanie telekomunikacyjnych urządzeń końcowych (np. telefonu) dla celów marketingu bezpośredniego przez Merkury Market Spółka z ograniczoną odpowiedzialnością Sp.k. z siedzibą w Krośnie. </span>*/}
                                    {/*</div>*/}
                                </div> :
                                <div className={'row'}>
                                    <div className={'col-sm-2 pr-0'}>
                                        <span>Imię:<Req/></span>
                                    </div>
                                    <div className={'col-sm-10'}>
                                        <input required type={'text'} className={'form-control'}
                                               value={inputValues.pole_imie}
                                               onChange={this.handleOnChange}
                                               name={'pole_imie'}/>
                                    </div>
                                    <div className={'col-sm-2 pr-0'}>
                                        <span>Nazwisko:<Req/></span>
                                    </div>
                                    <div className={'col-sm-10'}>
                                        <input required type={'text'} className={'form-control'}
                                               value={inputValues.pole_nazwisko}
                                               onChange={this.handleOnChange}
                                               name={'pole_nazwisko'}/>
                                    </div>
                                    <div className={'col-sm-2 pr-0'}>
                                        <span>Telefon:<Req/></span>
                                    </div>
                                    <div className={'col-sm-10'}>
                                        <input required type={'text'} className={'form-control'}
                                               value={inputValues.pole_telefon}
                                               onChange={this.handleOnChange}
                                               name={'pole_telefon'}/>
                                    </div>
                                    <div className={'col-sm-2 pr-0'}>
                                        <span>Kod pocztowy:<Req/></span>
                                    </div>
                                    <div className={'col-sm-10'}>
                                        <InputMask mask={[/\d/, /\d/, '-', /\d/, /\d/, /\d/]} className={'form-control'} style={{maxWidth: '120px', marginBottom: '10px'}}
                                                   value={inputValues.pole_kod_pocztowy}
                                                   onChange={this.handleOnChange}
                                                   name={'pole_kod_pocztowy'}
                                                   minLength={5}
                                                   required
                                        />
                                        {/*<input required type={'text'} className={'form-control'} style={{maxWidth: '120px'}}*/}
                                        {/*       value={inputValues.pole_kod_pocztowy}*/}
                                        {/*       onChange={this.handleOnChange}*/}
                                        {/*       name={'pole_kod_pocztowy'}/>*/}
                                    </div>
                                    <div className={'col-sm-2 pr-0'}>
                                        <span>Miejscowość:<Req/></span>
                                    </div>
                                    <div className={'col-sm-10'}>
                                        <input required type={'text'} className={'form-control'} value={inputValues.pole_miejscowosc}
                                               onChange={this.handleOnChange}
                                               maxLength={50}
                                               name={'pole_miejscowosc'}/>
                                    </div>
                                    <div className={'col-sm-2 pr-0'}>
                                        <span>Nazwa ulicy:</span>
                                    </div>
                                    <div className={'col-sm-10'}>
                                        <input type={'text'} className={'form-control'}
                                               value={inputValues.pole_ulica}
                                               onChange={this.handleOnChange}
                                               maxLength={40}
                                               name={'pole_ulica'}/>
                                    </div>
                                    <div className={'col-sm-2 pr-0'}>
                                        <span>Nr domu:<Req/></span>
                                    </div>
                                    <div className={'col-sm-10'}>
                                        <input required type={'text'} className={'form-control'} style={{maxWidth: '120px'}}
                                               value={inputValues.pole_nr_domu}
                                               onChange={this.handleOnChange}
                                               name={'pole_nr_domu'}/>
                                    </div>
                                    <div className={'col-sm-2 pr-0'}>
                                        <span>Nr mieszkania:</span>
                                    </div>
                                    <div className={'col-sm-10'}>
                                        <input type={'text'} className={'form-control'} style={{maxWidth: '120px'}}
                                               value={inputValues.pole_nr_mieszkania}
                                               onChange={this.handleOnChange}
                                               name={'pole_nr_mieszkania'}/>
                                    </div>

                                    <div className={'col-sm-2 pr-0'} style={{marginBottom: '15px'}}>
                                        <span>Twój sklep:<Req/></span>
                                    </div>
                                    <div className={'col-sm-10'} style={{marginBottom: '15px'}}>
                                        <select className={'form-control'}
                                                placeholder={'Wybierz...'}
                                                onChange={this.onChangeSklep}
                                                value={inputValues.numer_magazynu}
                                                required={true}
                                            //@ts-ignore
                                            //      value={((inputValues.numer_magazynu) !== 0) ? inputValues.numer_magazynu : null}
                                        >
                                            <option value={''} disabled selected hidden>Wybierz twój sklep...</option>
                                            {
                                                oddzialy.map((oddzial: any) => (
                                                    <option value={oddzial.numag}>{oddzial.adresPelen}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                    <div className={'col-sm-10 my-auto pr-0'} style={{textAlign: 'right'}}>
                                        <span>Numer Sprzedawcy polecającego:</span>
                                    </div>
                                    <div className={'col-sm-2 my-auto'}>
                                        {/*<InputMask mask={'aa'} className={'form-control'} style={{maxWidth: '40px'}}*/}
                                        {/*           value={inputValues.top_kod_sprzedawcy}*/}
                                        {/*           onChange={this.handleOnChange}*/}
                                        {/*           name={'top_kod_sprzedawcy'}*/}
                                        {/*/>*/}
                                        <input type={'text'} className={'form-control'} style={{maxWidth: '120px'}}
                                               value={inputValues.top_kod_sprzedawcy}
                                               onChange={this.handleOnChange}
                                               name={'top_kod_sprzedawcy'}/>
                                    </div>

                                    <div className={'col-sm-12'} style={{marginBottom: '25px'}}>
                                    </div>

                                    <div className={'col-sm-12'}>
                                        <CheckBox required={true} name={'zgoda_regulamin'} checked={inputValues['zgoda_regulamin']} handleOnChange={this.handleOnChecked}/>
                                        <span className={'checkbox-span'}><i>*</i> Oświadczam, iż zapoznałem się i akceptuję Regulamin programu lojalnościowego Karta Stałego Klienta</span>
                                    </div>

                                    <div className={'col-sm-12'}>
                                        <CheckBox required={true} name={'zgoda_wiek16'} checked={inputValues['zgoda_wiek16']} handleOnChange={this.handleOnChecked}/>
                                        <span className={'checkbox-span'}><i>*</i> Oświadczam, iż posiadam co najmniej 16 lat </span>
                                    </div>

                                    <div className={'col-sm-12'}>
                                        <CheckBox required={true} name={'zgoda_karta'} checked={inputValues['zgoda_karta']} handleOnChange={this.handleOnChecked}/>
                                        <span className={'checkbox-span'}><i>*</i> Zgodnie z art. 6 ust. 1 lit. a) Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem 	danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia Dyrektywy 95/46/WE (Dz. Urz. UE L 119 z 04.05.2016) – dalej RODO, wyrażam zgodę na przetwarzanie moich danych osobowych w celach związanych z realizacją programu lojalnościowego Karta Stałego Klienta przez Merkury Market Spółka z ograniczoną odpowiedzialnością Sp.k. z siedzibą w Krośnie. </span>
                                    </div>

                                    <div className={'col-sm-12'}>
                                        <CheckBox required={false} name={'zgoda_newsletter'} checked={inputValues['zgoda_newsletter']} handleOnChange={this.handleOnChecked}/>
                                        <span className={'checkbox-span'}>Zgodnie z art. 6 ust. 1 lit. a) RODO wyrażam zgodę na przetwarzanie moich danych osobowych w celu subskrypcji newslettera Merkury Market Spółka z ograniczoną odpowiedzialnością Sp.k. z siedzibą w Krośnie.                            </span>
                                    </div>

                                    <div className={'col-sm-12'}>
                                        <CheckBox required={false} name={'zgoda_push'} checked={inputValues['zgoda_push']} handleOnChange={this.handleOnChecked}/>
                                        <span className={'checkbox-span'}>Wyrażam zgodę na używanie telekomunikacyjnych urządzeń końcowych (np. telefonu) dla celów marketingu bezpośredniego przez Merkury Market Spółka z ograniczoną odpowiedzialnością Sp.k. z siedzibą w Krośnie. </span>
                                    </div>

                                {/*    <div className={'col-sm-2'}>*/}
                                {/*        <CheckBox required={true} name={'zgoda_regulamin'} checked={inputValues['zgoda_regulamin']} handleOnChange={this.handleOnChecked}/>*/}
                                {/*    </div>*/}
                                {/*    <div className={'col-sm-10 mb-2'}>*/}
                                {/*        <span className={'checkbox-span'}><i>*</i> Oświadczam, iż zapoznałem się i akceptuję Regulamin programu lojalnościowego Karta Stałego Klienta</span>*/}
                                {/*    </div>*/}
                                {/*    <div className={'col-sm-2'}>*/}
                                {/*        <CheckBox required={true} name={'zgoda_wiek16'} checked={inputValues['zgoda_wiek16']} handleOnChange={this.handleOnChecked}/>*/}
                                {/*    </div>*/}
                                {/*    <div className={'col-sm-10 mb-2'}>*/}
                                {/*<span*/}
                                {/*    className={'checkbox-span'}><i>*</i> Oświadczam, iż posiadam co najmniej 16 lat </span>*/}
                                {/*    </div>*/}
                                {/*    <div className={'col-sm-2'}>*/}
                                {/*        <CheckBox required={true} name={'zgoda_karta'} checked={inputValues['zgoda_karta']} handleOnChange={this.handleOnChecked}/>*/}
                                {/*    </div>*/}
                                {/*    <div className={'col-sm-10 mb-2'}>*/}
                                {/*        <span className={'checkbox-span'}><i>*</i> Zgodnie z art. 6 ust. 1 lit. a) Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem 	danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia Dyrektywy 95/46/WE (Dz. Urz. UE L 119 z 04.05.2016) – dalej RODO, wyrażam zgodę na przetwarzanie moich danych osobowych w celach związanych z realizacją programu lojalnościowego Karta Stałego Klienta przez Merkury Market Spółka z ograniczoną odpowiedzialnością Sp.k. z siedzibą w Krośnie. </span>*/}
                                {/*    </div>*/}
                                {/*    <div className={'col-sm-2'}>*/}
                                {/*        <CheckBox required={false} name={'zgoda_newsletter'} checked={inputValues['zgoda_newsletter']} handleOnChange={this.handleOnChecked}/>*/}
                                {/*    </div>*/}
                                {/*    <div className={'col-sm-10 mb-2'}>*/}
                                {/*        <span className={'checkbox-span'}>Zgodnie z art. 6 ust. 1 lit. a) RODO wyrażam zgodę na przetwarzanie moich danych osobowych w celu subskrypcji newslettera Merkury Market Spółka z ograniczoną odpowiedzialnością Sp.k. z siedzibą w Krośnie.                            </span>*/}
                                {/*    </div>*/}
                                {/*    <div className={'col-sm-2'}>*/}
                                {/*        <CheckBox required={false} name={'zgoda_push'} checked={inputValues['zgoda_push']} handleOnChange={this.handleOnChecked}/>*/}
                                {/*    </div>*/}
                                {/*    <div className={'col-sm-10 mb-2'}>*/}
                                {/*        <span className={'checkbox-span'}>Wyrażam zgodę na używanie telekomunikacyjnych urządzeń końcowych (np. telefonu) dla celów marketingu bezpośredniego przez Merkury Market Spółka z ograniczoną odpowiedzialnością Sp.k. z siedzibą w Krośnie. </span>*/}
                                {/*    </div>*/}
                                </div>
                            }
                        </section>
                        <div className={'buttons-line'}>
                            <button className={'btn btn-custom-secondary'} disabled={rejestracja || loginError}>{(migracja)? ((rejestracja)? <><i className="fa fa-spinner fa-spin"/> zapisywanie...</> : 'Zapisz') : ((rejestracja)? <><i className="fa fa-spinner fa-spin"/> trwa rejestracja...</> : 'Zarejestruj')}</button>
                        </div>
                    </form>
                    <hr/>
                    <div>
                        <small>Zgodnie z art. 13 RODO Merkury Market Spółka z ograniczoną odpowiedzialnością Sp.k. z siedzibą w
                            Krośnie informuje, że:
                            1) administratorem Pani/Pana danych osobowych jest Merkury Market Spółka z ograniczoną
                            odpowiedzialnością Sp.k. z siedzibą w Krośnie (ul. Czajkowskiego 51, 38-400 Krosno),
                            2) Pani/Pana dane osobowe przetwarzane będą dla potrzeb obsługi programu lojalnościowego Karty
                            Stałego
                            Klienta - na podstawie art. 6 ust. 1 lit. a) RODO, w przypadku wyrażenia zgody pkt 4 - Pani/Pana
                            dane
                            osobowe przetwarzane będą w celu subskrypcji newslettera na podstawie art. 6 ust. 1 lit. a) RODO, a
                            w
                            przypadku wyrażenia zgody pkt 5 - Pani/Pana dane osobowe przetwarzane będą dla celów marketingu
                            bezpośredniego na podstawie art. 6 ust. 1 lit. f) RODO,
                            3) Pana/Pani dane osobowe będą przetwarzane do dnia cofnięcia udzielonych powyżej zgód na
                            przetwarzanie
                            danych osobowych, jednak nie dłużej niż: (i) w przypadku wyrażenia zgody na przetwarzanie danych
                            osobowych w celach związanych z realizacją programu lojalnościowego Karty Stałego Klienta – przez
                            okres
                            uczestnictwa w programie, a po tym czasie w zakresie wymaganym przez przepisy prawa lub dla
                            zabezpieczenia ewentualnych roszczeń, (ii) w przypadku wyrażenia zgody na przetwarzanie danych
                            osobowych
                            w celu subskrypcji newslettera - nie dłużej niż do dnia żądania usunięcia z subskrypcji, (iii) w
                            przypadku wyrażenia zgody na używanie telekomunikacyjnych urządzeń końcowych – nie dłużej niż do
                            czasu
                            wniesienia sprzeciwu wobec przetwarzania,
                            4) posiada Pani/Pan prawo do żądania od Administratora dostępu do danych osobowych, prawo do ich
                            sprostowania, usunięcia lub ograniczenia przetwarzania, prawo do wniesienia sprzeciwu wobec
                            przetwarzania, prawo do przenoszenia danych, prawo do cofnięcia zgody w dowolnym momencie,
                            5) ma Pani/Pan prawo wniesienia skargi do organu nadzorczego,
                            6) ma Pani/Pan prawo do kontaktu z Inspektorem Ochrony Danych Osobowych pod adresem:
                            inspektor@merkurymarket.pl,
                            7) podanie danych osobowych jest warunkiem wydania Karty Stałego Klienta lub korzystania z tej
                            Karty, w
                            przypadku wyrażenia zgody pkt 4 i 5 - podanie danych osobowych jest dobrowolne,
                            8) Pani/Pana dane będą przetwarzane w sposób zautomatyzowany, w tym również w formie profilowania –
                            dotyczy subskrypcji newslettera.</small>
                    </div>
                    </Box>
                </Main>
            :
                <Main active={'REGISTER'}>
                    <Box>
                        <h3 style={{color: 'green'}}><i className="fa fa-check" style={{color: 'green'}}/> Dziękujemy za rejestrację !</h3>
                        <p>Na podany adres e-mail została wysłana wiadomość z linkiem aktywacyjnym.</p>
                    </Box>
                </Main>

        );
    }
}

export default Register;


